/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_OpenInputs */

const th_team_open = /** @type {(inputs: Team_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิด`)
};

const en_team_open = /** @type {(inputs: Team_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

const ja_team_open = /** @type {(inputs: Team_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開く`)
};

const zh_team_open = /** @type {(inputs: Team_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开`)
};

const es_team_open = /** @type {(inputs: Team_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir`)
};

const pt_team_open = /** @type {(inputs: Team_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir`)
};

const id_team_open = /** @type {(inputs: Team_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka`)
};

const fr_team_open = /** @type {(inputs: Team_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir`)
};

const tl_team_open = /** @type {(inputs: Team_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buksan`)
};

const vi_team_open = /** @type {(inputs: Team_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mở`)
};

const ko_team_open = /** @type {(inputs: Team_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`열기`)
};

const de_team_open = /** @type {(inputs: Team_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffnen`)
};

const ru_team_open = /** @type {(inputs: Team_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открыть`)
};

const tr_team_open = /** @type {(inputs: Team_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aç`)
};

const it_team_open = /** @type {(inputs: Team_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri`)
};

const pl_team_open = /** @type {(inputs: Team_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otwórz`)
};

const uk_team_open = /** @type {(inputs: Team_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відкрити`)
};

const hi_team_open = /** @type {(inputs: Team_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खोलें`)
};

const ar_team_open = /** @type {(inputs: Team_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فتح`)
};

const ms_team_open = /** @type {(inputs: Team_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka`)
};

const bn_team_open = /** @type {(inputs: Team_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`খুলুন`)
};

const zh_tw2_team_open = /** @type {(inputs: Team_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開啟`)
};

const zh_hk2_team_open = /** @type {(inputs: Team_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開啟`)
};

const ur_team_open = /** @type {(inputs: Team_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کھولیں`)
};

const fa_team_open = /** @type {(inputs: Team_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`باز کردن`)
};

const sw_team_open = /** @type {(inputs: Team_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fungua`)
};

const nl_team_open = /** @type {(inputs: Team_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Openen`)
};

/**
* | output |
* | --- |
* | "Open" |
*
* @param {Team_OpenInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const team_open = /** @type {((inputs?: Team_OpenInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_OpenInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_team_open(inputs)
	if (locale === "ja") return ja_team_open(inputs)
	if (locale === "zh") return zh_team_open(inputs)
	if (locale === "es") return es_team_open(inputs)
	if (locale === "pt") return pt_team_open(inputs)
	if (locale === "id") return id_team_open(inputs)
	if (locale === "fr") return fr_team_open(inputs)
	if (locale === "tl") return tl_team_open(inputs)
	if (locale === "vi") return vi_team_open(inputs)
	if (locale === "ko") return ko_team_open(inputs)
	if (locale === "de") return de_team_open(inputs)
	if (locale === "ru") return ru_team_open(inputs)
	if (locale === "tr") return tr_team_open(inputs)
	if (locale === "it") return it_team_open(inputs)
	if (locale === "pl") return pl_team_open(inputs)
	if (locale === "uk") return uk_team_open(inputs)
	if (locale === "hi") return hi_team_open(inputs)
	if (locale === "ar") return ar_team_open(inputs)
	if (locale === "ms") return ms_team_open(inputs)
	if (locale === "bn") return bn_team_open(inputs)
	if (locale === "zh-TW") return zh_tw2_team_open(inputs)
	if (locale === "zh-HK") return zh_hk2_team_open(inputs)
	if (locale === "ur") return ur_team_open(inputs)
	if (locale === "fa") return fa_team_open(inputs)
	if (locale === "sw") return sw_team_open(inputs)
	if (locale === "nl") return nl_team_open(inputs)
	return en_team_open(inputs)
});